import supplierIcon from "@iconify-icons/mdi/account-supervisor-circle";
import utilizerIcon from "@iconify-icons/mdi/group";
import leafCircleOutlineIcon from "@iconify-icons/mdi/leaf-circle-outline";
import { Icon } from "@iconify/react";
import { Box, Grid, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import comparison from "../assets/comparison.jpg";
import organization from "../assets/organization.png";
import sector from "../assets/sector.png";
import { useAuth } from "../authentication/AuthProvider";
import { MainContainer } from "../components/container/MainContainer";
import routing from "../routing";
import "../style/components-style/HomePageTab.css";
import muiSytle from "../style/components-style/muiStyle";
import "../style/pages-style/HomePage.css";

const backgroundSX = {
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  width: "100%",
  cursor: "pointer",
  opacity: 0.8,
  "&:hover": { opacity: 1, "& > div": { opacity: 0.95 } },
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};
const gridItemSX = { height: "100%", "&:hover": { borderColor: "seagreen", borderWidth: 4 } };
const titleSX = { color: "black", fontSize: 40, fontWeight: 200 };
const descriptionSX = { color: "black", fontSize: 30, fontWeight: 200 };
function HomePage() {
  const { t } = useTranslation();
  const { isEngagementEnabled, isOrganizationEnabled, isProductEnabled, isProjectEnabled, isBuildingEnabled } = useAuth();
  const navigate = useNavigate();

  const sectorLink = useMemo(() => {
    if (isProductEnabled) return routing.sector.products.dashboard;
    if (isProjectEnabled) return routing.sector.projects.dashboard;
    if (isBuildingEnabled) return routing.sector.buildings.dashboard;
    return routing.sector.products.dashboard;
  }, [isProductEnabled, isProjectEnabled, isBuildingEnabled]);

  const features = useMemo(
    () => [
      {
        icon: leafCircleOutlineIcon,
        title: t("Sector"),
        description: t("Sector"),
        link: sectorLink,
        image: sector,
        visibility: isProductEnabled || isProjectEnabled || isBuildingEnabled,
      },
      {
        icon: supplierIcon,
        title: t("Organization"),
        description: t("Organization"),
        link: routing.organization.supply_chain.dashboard,
        image: organization,
        visibility: isOrganizationEnabled,
      },
      {
        icon: utilizerIcon,
        title: t("Engagement"),
        description: t("Engagement"),
        link: routing.engagement.supplier_directory.dashboard,
        image: comparison,
        visibility: isEngagementEnabled,
      },
    ],
    [t, isEngagementEnabled, isOrganizationEnabled, isProductEnabled, isProjectEnabled, isBuildingEnabled, sectorLink]
  );
  return (
    <MainContainer sx={{ height: { lg: "calc(100vh - 110px)" } }}>
      <Grid container spacing={2} sx={{ height: "100%" }}>
        {features.map((f, i) => (
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 4, xl: 4 }} key={i} sx={{ ...muiSytle.commonContainer, ...gridItemSX, display: f.visibility ? "block" : "none" }}>
            <Box onClick={() => navigate(f.link)} sx={{ backgroundImage: `url(${f.image})`, ...backgroundSX }}>
              <Box sx={{ backgroundColor: "#fafafa", opacity: 0.85, paddingY: 4 }}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Box>
                    <Icon icon={f.icon} color="#16a34a" fontSize={60} />
                  </Box>
                </Box>
                <Box>
                  <Typography sx={titleSX}>{f.title}</Typography>
                </Box>
                <Box>
                  <Typography sx={descriptionSX}>{f.description}</Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </MainContainer>
  );
}

export default HomePage;
